export const FORM_SUBMIT_START = 'STARTED/FORM/SUBMIT'
export const FORM_SUBMIT_STOP = 'STOPPED/FORM/SUBMIT'
export const WRITING_FORM_SUBMIT_REQUESTED = 'WRITING_REQUEST/FORM/SUBMIT'
export const FORM_SUBMIT_SUCCEEDED = 'SUCCEEDED/FORM/SUBMIT'
export const FORM_SUBMIT_FAILED = 'FAILED/FORM/SUBMIT'
export const FORM_LOADED = 'FORM/LOADED'
export const FORM_AUTH_COMPLETE = 'FORM/AUTH/COMPLETE'
